module.exports = __webpack_public_path__ + "static/media/why-us.ce7ec00d.md";